import { render } from "./b-footer.vue?vue&type=template&id=c13b741c&ts=true"
import script from "./b-footer.vue?vue&type=script&lang=ts"
export * from "./b-footer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/hub_thunnus/hub_thunnus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/biz/b-footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c13b741c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c13b741c', __exports__)) {
    console.log('reload')
    api.reload('c13b741c', __exports__)
  }
  
  module.hot.accept("./b-footer.vue?vue&type=template&id=c13b741c&ts=true", () => {
    console.log('re-render')
    api.rerender('c13b741c', render)
  })

}


export default __exports__